'use client'

import React from "react";
import { Col, Row } from "react-bootstrap";
import { LifePart } from "../state/LifePart";

interface RolesListProps {
    rolesList: LifePart[];
    selectedRole?: LifePart | null;
    onClick?: (role: LifePart) => void;
    isMobile?: boolean;
}

export default function RolesList({ rolesList, selectedRole, onClick, isMobile }: RolesListProps) {
    const handleClick = (role: LifePart) => {
        if (onClick) {
            onClick(role);
        }
    };

    return (
        <div className="d-flex flex-wrap gap-2 justify-content-center">
            <Row>
                {rolesList.map((part, index) => (
                    <Col xs={12} lg={isMobile ? 12 : 6} key={part.uuid} className="mb-2">
                        <div
                            className={`d-flex align-items-center px-2 py-1 border rounded ${selectedRole?.uuid === part.uuid ? 'bg-primary text-white' : ''}`}
                            style={{ backgroundColor: selectedRole?.uuid === part.uuid ? undefined : 'white', cursor: 'pointer' }}
                            onClick={() => handleClick(part)}
                        >
                            <span
                                className="d-inline-block me-1 rounded"
                                style={{
                                    width: 16,
                                    minWidth: 16,
                                    height: 16,
                                    backgroundColor: part.color || '#000000'
                                }}
                            />
                            <span
                                className={isMobile ? "me-3 fw-bold" : "me-1 fw-bold"}
                                style={{ color: selectedRole?.uuid === part.uuid ? 'white' : (part.color || '#000000') }}
                            >
                                #{index + 1}
                            </span>
                            <span className={!isMobile ? "text-truncate" : ""}>{part.name}</span>
                        </div>
                    </Col>
                ))}
            </Row>
        </div>
    );
}
